<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>

<div *ngIf="AccessAllowed" class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Time Sets
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Time sets allow you to vary the times a package is sold for various different time such as school holidays.
    </p>
    <div style="text-align: right; margin-bottom: 20px;">

        <p-toggleButton class="p-button-sm p-button-danger p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'height': '50px'}" (click)="toggleDisabled()">
        </p-toggleButton>

        <span class="p-input-icon-left ml-auto" style="margin-right:20px; "> 
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="TimeSetsTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Timeset Name"/>
        </span>
        
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/timesetedit/0']" i18>
        <span class="pi pi-plus" style="margin-right:8px;"></span>
        <span i18>Add</span>
        </button>
        &nbsp;
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span i18>Disable</span>
        </button>
    </div>
    <div  class="surface-card p-4 shadow-2 border-round">
    <p-table  #TimeSetsTable 
    [value]="ListTimesets.data" sortField="name" [paginator]="true" [rows]="10" 
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" 
    [rowsPerPageOptions]="[10,25,50]" 
    [globalFilterFields]="['name']"
    [(selection)]="selectedItems"
    responsiveLayout="scroll"
    datakey="TimeSetsID"
    [selectionPageOnly]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pSortableColumn="name" width="90%">Name
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th width="5%"></th>
                <th width="5%"></th>
                <th width="5%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr style="background-color:#fee" *ngIf="data.disabled==true && data.isactive==false">
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td *ngIf="!data.isdefault">{{data.name}}</td>
                <td *ngIf="data.isdefault" style="font-weight:bold;"><i>{{data.name + " (Default)"}}</i></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component"(click)="viewData(data.id);" i18>
                    <span class="pi pi-eye" style="margin-right:8px;"></span>
                    <span i18n>View</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component"  style="margin-left:-20px;" (click)="editData(data.id);" i18>
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    <span i18n>Edit</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component"  style="margin-left:-20px;" (click)="disableData(data.id)" i18>
                    <span class="pi pi-trash" style="margin-right:8px;"></span>
                    <span i18n>Disable</span>
                </button></td>
            </tr>

            <tr style="background-color:#FFFFFF" *ngIf="data.disabled==false && data.isactive==false">
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td *ngIf="!data.isdefault">{{data.name}}</td>
                <td *ngIf="data.isdefault" style="font-weight:bold;"><i>{{data.name + " (Default)"}}</i></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component"(click)="viewData(data.id);" i18>
                    <span class="pi pi-eye" style="margin-right:8px;"></span>
                    <span i18n>View</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component"  style="margin-left:-20px;" (click)="editData(data.id);" i18>
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    <span i18n>Edit</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component"  style="margin-left:-20px;" (click)="disableData(data.id)" i18>
                    <span class="pi pi-trash" style="margin-right:8px;"></span>
                    <span i18n>Disable</span>
                </button></td>
            </tr>
 
            <tr style="background-color:#dfd" *ngIf="data.disabled==false && data.isactive==true">
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td *ngIf="!data.isdefault">{{data.name}}</td>
                <td *ngIf="data.isdefault" style="font-weight:bold;"><i>{{data.name + " (Default)"}}</i></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component"(click)="viewData(data.id);" i18>
                    <span class="pi pi-eye" style="margin-right:8px;"></span>
                    <span i18n>View</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component"  style="margin-left:-20px;" (click)="editData(data.id);" i18>
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    <span i18n>Edit</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component"  style="margin-left:-20px;" (click)="disableData(data.id)" i18>
                    <span class="pi pi-trash" style="margin-right:8px;"></span>
                    <span i18n>Disable</span>
                </button></td>
            </tr>

            <tr style="background-color:#dfd" *ngIf="data.disabled==true && data.isactive==true">
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td *ngIf="!data.isdefault">{{data.name}}</td>
                <td *ngIf="data.isdefault" style="font-weight:bold;"><i>{{data.name + " (Default)"}}</i></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component"(click)="viewData(data.id);" i18>
                    <span class="pi pi-eye" style="margin-right:8px;"></span>
                    <span i18n>View</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component"  style="margin-left:-20px;" (click)="editData(data.id);" i18>
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    <span i18n>Edit</span>
                </button></td>
                <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component"  style="margin-left:-20px;" (click)="disableData(data.id)" i18>
                    <span class="pi pi-trash" style="margin-right:8px;"></span>
                    <span i18n>Disable</span>
                </button></td>
            </tr> 
        </ng-template>
    </p-table>
    </div>
</div>
